import React from "react";
import { Row, Col, Typography, Space } from "antd";
import {
  LinkedinOutlined,
  FacebookOutlined,
  TwitterOutlined,
  YoutubeOutlined,
} from "@ant-design/icons";
import FooterImg from "../../assets/images/FooterImg.svg";
import FooterImg2 from "../../assets/images/FooterImg2.svg";
import FooterImg3 from "../../assets/images/FooterImg3.svg";
import FooterImg4 from "../../assets/images/FooterImg4.svg";
import FooterImg5 from "../../assets/images/FooterImg5.svg";
import FooterImg6 from "../../assets/images/FooterImg6.svg";

const { Title, Text } = Typography;

const Footer = () => {
  const sections = {
    HOSTING: [
      "Web Hosting",
      "Professional web hosting",
      "VPS Hosting",
      "Minecraft server hosting",
      "CyberPanel Hosting",
      "Cloud hosting",
      "Managed WordPress Hosting",
      "Managed WooCommerce hosting",
      "Business Email",
      "Google Workspace",
      "CMS hosting",
      "eCommerce Hosting",
      "Plesk hosting",
      "Game server hosting",
    ],
    DOMAINS: [
      "Domain Name Search",
      "Domain Transfer",
      "Free Domain",
      "XYZ domain",
      "Cheap Domain Names",
      "Domain Extensions",
      "WHOIS Lookup",
      "Free SSL certificate",
    ],
    INFORMATION: [
      "Migrate to Hostinger",
      "System status",
      "Affiliate program",
      "Referral program",
      "Payment methods",
      "Wall of fame",
      "Reviews",
      "Pricing",
      "Sitemap",
    ],
    COMPANY: [
      "About Hostinger",
      "Our technology",
      "Career",
      "Newsroom",
      "Roadmap",
      "Contact us",
      "Blog",
      "Student discount",
      "Talk to sales",
    ],
    TOOLS: [
      "Landing page builder",
      "AI landing page builder",
      "Website builder",
      "AI website builder",
      "Wedding website builder",
      "Photography website",
      "Blog maker",
      "Business website",
      "Website design",
      "AI Logo Generator",
      "Business name generator",
      "Ecommerce website",
      "Portfolio website",
      "Restaurant website builder",
      "Website templates",
    ],
    LEGAL: ["Privacy policy", "Terms of service", "Refund policy"],
    HELP: ["Tutorials", "Knowledge base", "Report abuse"],
  };

  return (
    <div style={{ background: "#f5f5ff", padding: "40px 20px" }}>
      <Row gutter={[32, 32]}>
        {/* Logo + Description + Payment Icons */}
        <Col xs={24} sm={24} md={6}>
          <Title level={4}>HOSTINGER</Title>
          <Text>
            We are a web hosting provider on a mission to bring success to
            everyone online. We constantly improve our server technology,
            provide professional support, and simplify site creation with our AI
            Website Builder.
          </Text>
          <Space style={{ marginTop: 16 }}>
            <img src={FooterImg} alt="Visa" width={40} />
            <img src={FooterImg2} alt="JCB" width={40} />
            <img src={FooterImg3} alt="Maestro" width={40} />
            <img src={FooterImg4} alt="Amex" width={40} />
            <img src={FooterImg5} alt="Discover" width={40} />
            <img src={FooterImg6} alt="Paypal" width={40} />
          </Space>
        </Col>

        {/* Footer Sections */}
        {Object.keys(sections).map((section) => (
          <Col xs={12} sm={12} md={2} key={section}>
            <Title level={5}>{section}</Title>
            <Space direction="vertical">
              {sections[section].map((item, idx) => (
                <Text key={idx} style={{ display: "block" }}>
                  {item}
                </Text>
              ))}
            </Space>
          </Col>
        ))}
      </Row>

      {/* Social Icons + Copyright */}
      {/* BOTTOM COPYRIGHT BAR */}
      <Row
        align="middle"
        style={{
          marginTop: 40,
          borderTop: "1px solid #e5e7ff",
          paddingTop: 16,
          fontSize: 12,
          color: "#5a5a89",
        }}
      >
        {/* CENTER TEXT */}
        <Col xs={24} md={18} style={{ textAlign: "center" }}>
          © 2004–2024 hostinger.com – Premium Web Hosting, Cloud, VPS, AI
          Website Builder & Domain Registration Services.
        </Col>

        {/* RIGHT TEXT */}
        <Col xs={24} md={6} style={{ textAlign: "right" }}>
          Prices are listed without VAT
        </Col>
      </Row>
    </div>
  );
};

export default Footer;
